import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("gd_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response && err.response.status === 401) {
      localStorage.removeItem("gd_token");
      localStorage.removeItem("gd_user");
      if (!window.location.pathname.startsWith("/login") && !window.location.pathname.startsWith("/forgot")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);
